import { render, staticRenderFns } from "./DefaultStyle.vue?vue&type=template&id=ec63c95a&scoped=true&"
import script from "./DefaultStyle.vue?vue&type=script&lang=js&"
export * from "./DefaultStyle.vue?vue&type=script&lang=js&"
import style0 from "./DefaultStyle.vue?vue&type=style&index=0&id=ec63c95a&lang=scss&scoped=true&"
import style1 from "./DefaultStyle.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec63c95a",
  null
  
)

export default component.exports